<template>
  <div v-if="selectedClassId || selectedTeacherId" class="ma-6">
    <div class="d-flex justify-end pb-6" v-if="selectedClassId">
      <v-btn outlined color="success" @click="exportExcel"> <v-icon left>mdi-file-excel</v-icon> Xuất Excel </v-btn>
    </div>
    <table>
      <tr style="height: 61px">
        <th></th>
        <th>Thứ 2</th>
        <th>Thứ 3</th>
        <th>Thứ 4</th>
        <th>Thứ 5</th>
        <th>Thứ 6</th>
        <th>Thứ 7</th>
      </tr>
      <tr v-for="index in 12" :key="index" :class="index != 1 && index != 7 ? 'daySection' : ''">
        <td v-if="index === 1 || index === 7" colspan="7" class="text-center font-weight-bold">
          {{ index === 1 ? 'Sáng' : 'Chiều' }}
        </td>
        <template v-else>
          <td class="text-center">Tiết {{ 7 > index ? index - 1 : index - 2 }}</td>
          <TimeTableCell
            v-for="day in 6"
            :slotData="slots[`${7 > index ? index - 1 : index - 2}-${day}`]"
            :day="day"
            :index="7 > index ? index - 1 : index - 2"
            :key="day"
            :type="type"
          />
        </template>
      </tr>
    </table>
  </div>
</template>

<script>
import TimeTableCell from '@/modules/timeTable/TimeTableCell.vue'
import Excel from 'exceljs'
import LoadAsset from 'load-asset'
import { saveAs } from 'file-saver'
import { Slot } from '../../plugins/api'
import { keyBy } from 'lodash'
import { textHelpers } from '@/helpers/TextHelper.js'

export default {
  components: {
    TimeTableCell
  },
  props: {
    slots: Object,
    type: String,
    selectedClassId: String,
    selectedTeacherId: String
  },
  data() {
    return {
      classData: {}
    }
  },
  methods: {
    getTeacherName(teacher) {
      if (teacher) {
        const name = textHelpers.getLastName(teacher.name)
        return teacher.gender === 'male' ? `T. ${name}` : `C. ${name}`
      }
      return ''
    },
    getContent(slot) {
      if (slot) {
        return slot.subject.title + '\n' + this.getTeacherName(slot.teacher)
      }
      return ''
    },
    async exportExcel() {
      this.$loading.active = true

      try {
        const workbook = new Excel.Workbook()
        const buffer = await LoadAsset({ url: '/schedule.xlsx', type: 'binary' })
        await workbook.xlsx.load(buffer)
        const worksheet = workbook.getWorksheet('sheet')

        const params = {
          class: this.selectedClassId,
          _limit: -1,
          status_ne: 'inactive',
          _sort: 'index:ASC,day:ASC'
        }
        const slots = await Slot.fetch(params)
        const slotObj = keyBy(slots, 'indexDay')

        for (let index = 1; index <= 10; index++) {
          let rowIndex = index + 2
          if (index >= 6) {
            rowIndex = rowIndex + 1
          }

          worksheet.getCell(`B${rowIndex}`).value = this.getContent(slotObj[`${index}-1`])
          worksheet.getCell(`C${rowIndex}`).value = this.getContent(slotObj[`${index}-2`])
          worksheet.getCell(`D${rowIndex}`).value = this.getContent(slotObj[`${index}-3`])
          worksheet.getCell(`E${rowIndex}`).value = this.getContent(slotObj[`${index}-4`])
          worksheet.getCell(`F${rowIndex}`).value = this.getContent(slotObj[`${index}-5`])
          worksheet.getCell(`G${rowIndex}`).value = this.getContent(slotObj[`${index}-6`])
        }

        const excelBuffer = await workbook.xlsx.writeBuffer()
        const blob = new Blob([excelBuffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        saveAs(blob, `ThoiKhoaBieu.xlsx`)
      } catch (error) {
        console.error(error)
        this.$alert.error('Xuất excel thất bại. Lỗi: ' + error)
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
table {
  width: 100%;
  border-collapse: collapse;
}
th,
td {
  white-space: nowrap;
  padding: 8px;
  border: 1px solid #ddd;
}
.daySection {
  height: 61px;
}
</style>
